<template>
  <nav class="navbar navbar-expand-md fixed-top navbar-light bg-white">
    <div class="container-fluid p-0">
      <div class="d-none d-md-block brand-indent">

      </div>
      <!--<router-link :to="{ name: 'welcome' }" class="navbar-brand">
        {{ appName }}
      </router-link>-->
      <router-link :to="{ name: 'home' }" class="navbar-brand">
        <img src="/images/logo.svg" class="img-fluid" alt="logo" style="max-width: 45%">
      </router-link>

      <div class="collapse navbar-collapse" id="navbarToggler">
        <div class="navbar-nav ml-auto mt-2 mt-lg-0">
          <b-btn class="mr-3" variant="danger" v-if="originalToken" @click="revertUser">
            <fa icon="sign-out-alt"/> Revert User
          </b-btn>
          <locale-dropdown/>
        </div>
        <ul class="navbar-nav">
          <template v-if="!user">
            <li class="nav-item">
              <router-link :to="{ name: 'login' }" class="nav-link" active-class="active">
                {{ $t('core.login') }}
              </router-link>
            </li>
          </template>
        </ul>
      </div>
      <div class="d-md-none">
        <fa icon="bars" size="lg" @click="toggleSidebar"/>
      </div>
    </div>
  </nav>
</template>

<script>
  import {mapGetters} from 'vuex'
  import LocaleDropdown from './LocaleDropdown'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

  export default {
    name: 'o-navbar',
    data: () => ({
      appName: window.config.appName
    }),

    computed: mapGetters({
      user: 'auth/user',
      originalToken: 'auth/originalToken'
    }),

    components: {
      LocaleDropdown,
      FontAwesomeIcon
    },

    methods: {
      async logout() {
        // Log out the user.
        await this.$store.dispatch('auth/logout')

        // Redirect to login.
        this.$router.push({name: 'login'})
      },
      revertUser() {
        this.$store.dispatch('auth/revertOriginalToken')
        const usersPage = this.$router.resolve({ name: 'system.user_list' })
        window.location.href = usersPage.href
      },
      toggleSidebar() {
        this.$emit('toggle-sidebar')
      }
    }
  }
</script>
